export enum PatientSubmissionDataTypes {
  Wearable = 'wearable',
  Caretask = 'answerCollection',
}
